globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Settings = appCustomerSpace.Controllers.Settings || {};

appCustomerSpace.Controllers.Settings.MainController = (function(superClass)
{
  utils.extend(MainController, superClass);

  function MainController() {
    return MainController.__super__.constructor.apply(this, arguments);
  }

  $.extend(MainController.prototype, {
    init: function() {
      this.initDnsClipboard();
      return MainController.__super__.init.apply(this, arguments);
    },

    initDnsClipboard: function() {
      $(document).on('click', '.dns-clipboard', function() {
        var $button = $(this);
        var text = $button.data('copy-text');
        var $icon = $button.find('i');
        var originalIconClass = $icon.attr('class');

        navigator.clipboard.writeText(text).then(function() {
          $button.attr('data-original-title', 'Copié !').tooltip('show').blur();

          if (!$icon.length) return;

          $icon.attr('class').split(' ').forEach(function(className) {
            if (className.startsWith('fa-')) {
              $icon.removeClass(className);
            }
          });
          $icon.addClass('fa-check');

          setTimeout(function() {
            $icon.attr('class', originalIconClass);
            $button.attr('data-original-title', 'Copier');
          }, 2000);
        });
      });
    },

    initActionCableEmailingSendersChannel: function(params) {
      if (!params.project_uniq_key) {
        return;
      }

      App.cable.subscriptions.create({
        channel: "CustomerSpace::Settings::Emailing::SendersChannel",
        project_uniq_key: params.project_uniq_key
      }, {
        received: function(data) {
          switch (data.action) {
            case 'update_validation_status':
              var $statusElement = $(".td-validation-status-" + data.sender_uniq_key);

              if ($statusElement.length) {
                $statusElement.html(data.html);
              }
              break;
            case 'update_dns_records':
              var $dnsElement = $(".dns-records-container");

              if ($dnsElement.length) {
                $dnsElement.html(data.html);
              }
              break;
          }
        }
      });
    }
  });

  return MainController;

})(appCustomerSpace.Controllers.MainController);
